import { Alert, AlertDescription, AlertIcon, Box, BoxProps, Button, CircularProgress, CloseButton, FormErrorMessage, Heading, Progress } from "@chakra-ui/react";
import { MutableRefObject, ReactNode, createContext, PropsWithChildren } from "react";
import { MdClose } from "react-icons/md";

export interface IDeepLayoutCtx {
	editorElem: HTMLElement | null;
}

export const DeepLayoutCtx = createContext<IDeepLayoutCtx>({
	editorElem: null
})


export interface DeepProgressProps {
	isLoading: boolean;
}

export function DeepProgress({ isLoading }: DeepProgressProps) {
	return <>
		{isLoading && <Progress isIndeterminate height='3px' colorScheme="gray" />}
	</>
}


export interface DeepErrorBoxProps {
	isLoading?: boolean;
	error: unknown;
}

export function DeepErrorBox({ isLoading = false, error }: DeepErrorBoxProps) {
	return <>
		{isLoading && <Progress isIndeterminate size='sm' colorScheme='secondary' />}
		{error && <Alert status="error" bg='#db4545' color='#fff'>
			<AlertIcon /><AlertDescription>{'' + error}</AlertDescription>
		</Alert>}
	</>
}

export interface DeepErrorContainer extends PropsWithChildren<DeepErrorBoxProps> {
	onErrorClose: () => void,
}

export function DeepErrorContainer({ children, onErrorClose, isLoading = false, error }: DeepErrorContainer) {
	return <>{children}{(isLoading || !!error) && <Box position='absolute' left={0} right={0} top={0} bottom={0} display='flex' alignItems='center' justifyContent='center' bg='#0003' backdropFilter='blur(2px)' >
		<>
			{isLoading && <CircularProgress color="secondary.main" isIndeterminate size='110px' trackColor='#0003' thickness={5} />}
			{error && <Box display='flex' flexDir='column' alignItems='center' gap={3}>
				<Alert status="error" bg='#db4545' color='#fff'>
					<AlertIcon /><AlertDescription>{'' + error}</AlertDescription>
				</Alert>
				<Button onClick={onErrorClose} size='sm' leftIcon={<MdClose/>} >Bezár</Button>
			</Box>}
		</>
	</Box>}</>
}

export const DEEP_LINE_ERROR = 'Min 3 max 512 karakter!';
export function deepLineCheck(text: string) {
	return !!text && typeof text === 'string' && text.length >= 3 && text.length <= 512;
}


export interface SubHeadProps {
	title: ReactNode;
	tools: ReactNode;
}

export function SubHead({ title, tools }: SubHeadProps) {
	return <Box w='100%' display='flex' flexDir='row' justifyContent='space-between' alignItems='center'>
		<Heading size='sm' >{title}</Heading>
		<Box>
			{tools}
		</Box>
	</Box>
}

export function DeepNumber({ value }: { value: number }) {
	return <Box display='inline-block'
		bg='#ffe400' borderRadius='md' border='1px solid #8888' px='4px'
		fontWeight='bold'
		fontSize='sm'
	>{value}</Box>
}